export function Logo({ size = 40, showText = true, light = false, className = "" }) {
    return (
        <div className={`flex items-center gap-2.5 ${className}`} data-testid="homiie-logo">
            <img
                src="/homiie-logo.jpeg"
                alt="HOMIIE"
                width={size}
                height={size}
                className="rounded-xl object-cover"
                style={{ width: size, height: size }}
            />
            {showText && (
                <span
                    className={`font-heading font-extrabold tracking-tight ${light ? "text-white" : "text-navy"}`}
                    style={{ fontSize: size * 0.5 }}
                >
                    HOMIIE
                </span>
            )}
        </div>
    );
}
